// https://docs.google.com/document/d/1Dohdi7Uux58AUplbf37O0zEBzawGwQhHjQPbKYs8xTg/edit#heading=h.bdbgz1vivdjs

import { isBank } from '@/config/core';
import { browserInstance as browser } from '@/utils/browser';
import { redirectionTo } from '../tools';

export enum PlatformType {
  Android = 'android',
  IOS = 'ios'
}
export enum AppStoreType {
  Huawei = 'huawei',
  Google = 'google'
}
function getAppStore(): AppStoreType {
  const ua = window.navigator.userAgent.toLocaleLowerCase();
  // 判断huawei
  if (/huawei|honor/i.test(ua)) {
    return AppStoreType.Huawei;
  }
  return AppStoreType.Google;

}
const Platform = browser.android ? PlatformType.Android : PlatformType.IOS;
const AppStore = getAppStore();
export enum FacialVerificationResult {
  Success = 1,
  Failed = 2,
  Error = 3
}
export const HelpCenterLinkMap: any = {
  id: {
    live: 'https://app.seabank.co.id/help-center/home',
    uat: 'https://app-uat1.uat.seabank.co.id/help-center/home',
  },
  ph: {
    live: 'https://app.seabank.ph/help-center/home',
    uat: 'https://app-uat1.uat.seabank.ph/help-center/home',
  },
  sg: {
    live: 'https://app.maribank.com.sg/help-center/home',
    uat: 'https://app-uat1.uat.maribank.com.sg/help-center/home',
  },
};
// huawei与其他机型跳转不同的应用市场链接
export const VersionUpdateLinkMap: any = {
  id: {
    [PlatformType.IOS]: 'https://apps.apple.com/id/app/bank-bke/id1525477806',
    [PlatformType.Android]: { [AppStoreType.Google]: 'https://play.google.com/store/apps/details?id=id.co.bankbkemobile.digitalbank' },
  },
  ph: {
    [PlatformType.IOS]: 'https://itunes.apple.com/ph/app/seabank/id1592249158',
    [PlatformType.Android]: {
      [AppStoreType.Huawei]: 'https://appgallery.huawei.com/app/C106857809',
      [AppStoreType.Google]: 'https://play.google.com/store/apps/details?id=ph.seabank.seabank',
    },
  },
  sg: {
    [PlatformType.IOS]: 'https://apps.apple.com/sg/app/maribank/id1658919834',
    [PlatformType.Android]: {
      [AppStoreType.Huawei]: 'https://appgallery.huawei.com/app/C105796295',
      [AppStoreType.Google]: 'https://play.google.com/store/apps/details?id=sg.com.maribankmobile.digitalbank',
    },
  },
};
export const HelpCenterLink = HelpCenterLinkMap[COUNTRY]?.[ENVIRONMENT];
export const getVersionUpdateLink = () => {
  if (Platform === PlatformType.IOS) {
    return VersionUpdateLinkMap[COUNTRY]?.[Platform];
  } else {
    return VersionUpdateLinkMap[COUNTRY]?.[Platform]?.[AppStore] || VersionUpdateLinkMap[COUNTRY]?.[Platform]?.google;
  }
};

// 判断是否支持人脸验证
export function isSupportFacialVerification(): boolean {
  const liveChatSdkVersion = browser.liveChatSdkVersion || 0;
  const LiveChatSdkSupportFacialVerificationAppVersion = 10100; // 2023.10.13   LiveChatSDk 10100 版本增加faceAPI
  // bank 新版本的LiveChatSdk支持人脸识别
  if (isBank() && liveChatSdkVersion >= LiveChatSdkSupportFacialVerificationAppVersion) {
    return true;
  }
  return false;
}

// 触发版本升级弹窗
export function jumpToVersionUpdate(): void {
  redirectionTo(getVersionUpdateLink());

}
// 跳转到helpCenter
export function jumpToHelpCenter(): void {
  redirectionTo(HelpCenterLink);
}
